module.exports = __webpack_public_path__ + "img/GL2.8a76ed8a.jpg";